<template>
  <div class="ps-table-wrap">
    <ve-table
       :fixed-header="true"
        :columns="columns"
        :max-height="'calc(100vh - 210px)'"
        :sort-option="sortOption"
      :table-data="tableData"
      :border-around="true"
    />
    <empty-state v-if="showEmptyResult" :title="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.NO_RECORDS')" />
    <SpinnerWithMessage
        :isLoading="isLoading"
        :message="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.LOADING')"
        className=""
    />
    <!-- <div v-if="isLoading" class="call-campaign--loader">
      <spinner />
      <span>{{$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.LOADING')}}</span>
    </div> -->
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import SpinnerWithMessage from "shared/components/SpinnerWithMessage.vue";


export default {
    components:{
        VeTable,
        Spinner,
        EmptyState,
        SpinnerWithMessage,
    },
    props:{
        records:{
            type: Array,
            default: () => []
        },
        cols: {
            type: Array,
            default: () => [],
        },
        showEmptyResult: {
          type: Boolean,
          default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data(){
      return {
        sortConfig: {},
        sortOption: {
          sortAlways: true,
          sortIcons: {
            ascend: "top-arrow",
            descend: "bottom-arrow"
          },
          sortChange: params => this.$emit('on-sort-change', params),
        },
      }
    },
    computed: {
        tableData() {
          if (this.isLoading) {
              // return [];
          }
        //   return this.records;
        // Deep copy so you don't mutate original records
            return this.records.map(record => {
                // Clone the record shallowly
                const newRecord = { ...record };

                if (newRecord.response_data) {
                // Create a new object with truncated values
                const truncatedResponseData = {};
                Object.entries(newRecord.response_data).forEach(([key, value]) => {
                    if (typeof value === 'string' && value.length > 30) {
                    truncatedResponseData[key] = value.slice(0, 30) + '...';
                    } else {
                    truncatedResponseData[key] = value;
                    }
                });

                newRecord.response_data = truncatedResponseData;
                }

                return newRecord;
            });
        },
        columns() {
            let matches = {};

            // Static known columns
            matches.respondent_email = {
                field: 'respondent_email',
                key: 'respondent_email',
                title: 'Respondent Email',
                width: 280,
                align: 'left',
                renderBodyCell: ({ row }) => (
                <div onClick={() => this.onClickTitle(row)}>
                    <p class="clickableRow text_purple_primary">{row.respondent_email}</p>
                </div>
                ),
            };

            matches.respondent_phone = {
                field: 'respondent_phone',
                key: 'respondent_phone',
                title: 'Respondent Phone',
                width: 250,
                align: 'left',
                renderBodyCell: ({ row }) => <span>{row.respondent_phone}</span>,
            };

            // 1️⃣ Collect unique keys from response_data
            const dynamicKeys = new Set();
            this.records.forEach(record => {
                if (record.response_data) {
                Object.keys(record.response_data).forEach(k => {
                    dynamicKeys.add(k);
                });
                }
            });

            // 2️⃣ Create column config for each dynamic key
            dynamicKeys.forEach(key => {
                matches[key] = {
                field: key,
                key: key,
                title: key.replace(/_/g, ' '),
                width: 250, // default width for dynamic cols
                align: 'left',
                renderBodyCell: ({ row }) => (
                    <span>{row.response_data ? row.response_data[key] : ''}</span>
                ),
                };
            });

            // 3️⃣ Merge known cols and dynamic cols into final list
            const preSet = [];

            // Add all cols from props (if visible)
            this.cols.forEach(col => {
                if (col.visible && matches[col.key]) {
                preSet.push(matches[col.key]);
                }
            });

            // Add dynamic keys not in props.cols
            dynamicKeys.forEach(key => {
                if (!this.cols.find(c => c.key === key)) {
                preSet.push(matches[key]);
                }
            });
            // dynamicKeys.forEach(key => {
            //     matches[key] = {
            //         field: key,
            //         key: key,
            //         title: key.replace(/_/g, ' '),
            //         width: 180,
            //         align: 'left',
            //         renderBodyCell: ({ row }) => {
            //         const val = row.response_data ? row.response_data[key] : '';
            //         if (typeof val === 'string' && val.length > 50) {
            //             const truncated = val.slice(0, 50) + '...';
            //             return <span title={val}>{truncated}</span>;
            //         }
            //         return <span>{val}</span>;
            //         },
            //     };
            // });


            return preSet;
        },
    },

}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_ps_table.scss';


</style>